import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  GET_DEPARTMENT_LIST,
  GET_ALL_EMPLOYEES_LIST,
  GET_ALL_EMPLOYEES_NAME,
} from "../../config/Endpoints";
import Cookies from "js-cookie";
import { getApi } from "../../utils/api";
import { ThreeDots } from "react-loader-spinner";
import EmployeeCard from "./EmployeeCard";
import AssignManager from "../AssignManager/AssignManager";
import SendEmployeeOnboarding from "../EmployeeOnboard/SendEmployeeOnboarding";
import { toggleMenu } from "../../utils/helpers";
import Footer from "../../components/Footer";
import PageTitle from "../../components/PageTitle";
import Select from "react-select";
import NoRecordsAvailable from "../../components/NoRecordsAvailable";
import InfiniteScroll from "react-infinite-scroll-component";
import { TailSpin } from "react-loader-spinner";

function EmployeeList({ title, description }) {
  const [employees, setEmployees] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState("");
  const [designation, setDesignation] = useState("");
  const [isEmployeeLoading, setIsEmployeeLoading] = useState(false);
  const [isDepartmentLoading, setIsDepartmentLoading] = useState(false);
  const [selectedDepartmentId, setSelectedDepartmentId] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const isInitialLoading = isEmployeeLoading || isDepartmentLoading;

  const accessToken = Cookies.get("accessToken");
  const navigate = useNavigate();

  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const PAGE_SIZE = 8;

  useEffect(() => {
    fetchDepartmentList();
    fetchEmployeesList();
  }, []);

  useEffect(() => {
    if (selectedDepartmentId || selectedStatus || selectedEmployeeId) {
      setPage(1);
      setHasMore(true);
      setEmployees([]);
      fetchEmployees(
        1,
        true,
        selectedDepartmentId,
        selectedStatus,
        selectedEmployeeId,
      );
    }
  }, [selectedDepartmentId, selectedStatus, selectedEmployeeId]);

  useEffect(() => {
    if (!selectedDepartmentId && !selectedStatus && !selectedEmployeeId) {
      setPage(1);
      setHasMore(true);
      setEmployees([]);
      fetchEmployees(1, true, "", "", "");
    }
  }, [selectedDepartmentId, selectedStatus, selectedEmployeeId]);

  const fetchEmployeesList = () => {
    setIsEmployeeLoading(true);

    getApi(GET_ALL_EMPLOYEES_NAME, accessToken)
      .then((res) => {
        if (res.status === 200) {
          const list = res.data.data || [];

          setEmployeeOptions(
            list.map((emp) => ({
              value: emp.id,
              label: emp.empName,
              designation: emp.designation,
              status: emp.status,
              depId: emp.depId,
            })),
          );
        }
      })
      .finally(() => setIsEmployeeLoading(false));
  };

  const fetchEmployees = (
    pageNo = 1,
    reset = false,
    departmentId = selectedDepartmentId,
    status = selectedStatus,
    empId = selectedEmployeeId,
  ) => {
    reset ? setIsFilterLoading(true) : setIsLoading(true);

    const params = new URLSearchParams({
      page: pageNo - 1,
      size: PAGE_SIZE,
    });

    if (departmentId) params.append("departmentId", departmentId);
    if (status) params.append("status", status);
    if (empId) params.append("empId", empId);

    getApi(`${GET_ALL_EMPLOYEES_LIST}?${params}`, accessToken)
      .then((res) => {
        if (res.status === 200) {
          const newData = res.data.data?.content || [];
          setEmployees((prev) => (reset ? newData : [...prev, ...newData]));
          setHasMore(newData.length === PAGE_SIZE);
        }
      })
      .finally(() => {
        setIsLoading(false);
        setIsFilterLoading(false);
      });
  };

  const fetchNextPage = () => {
    if (searchTerm) return;
    const next = page + 1;
    setPage(next);
    fetchEmployees(next);
  };

  const fetchDepartmentList = () => {
    setIsDepartmentLoading(true);

    getApi(GET_DEPARTMENT_LIST, accessToken)
      .then((res) => {
        if (res.status === 200) {
          setDepartmentList(res.data.data);
        }
      })
      .finally(() => setIsDepartmentLoading(false));
  };

  const filteredEmployees = employees.filter((emp) =>
    emp.empName
      ?.replace(/\s/g, "")
      .toLowerCase()
      .includes(searchTerm.replace(/\s/g, "").toLowerCase()),
  );

  const handleDepartment = (option) => {
    const value = option?.value || "";
    setSelectedDepartmentId(value);
    setSelectedEmployeeId("");
    setDesignation("");

    setPage(1);
    setHasMore(true);
    setEmployees([]);
  };

  const handleStatus = (option) => {
    const value = option?.value || "";
    setSelectedStatus(value);
    setSelectedEmployeeId("");
    setDesignation("");
    setPage(1);
    setHasMore(true);
    setEmployees([]);
  };

  return (
    <div className="wrapper-body">
      {(isEmployeeLoading || isDepartmentLoading) && (
        <div className="overlay">
          <div className="loader-container">
            <TailSpin
              height="100"
              width="100"
              radius="1"
              color="blue"
              ariaLabel="tail-spin-loading"
              visible={true}
            />
          </div>
        </div>
      )}
      <div className="page-heading">
        <div id="showMenuBtn" className="collapse-button" onClick={toggleMenu}>
          <span />
          <span />
          <span />
        </div>

        <PageTitle title={title} description={description} />

        <div className="total">
          Total Employees : <span>{filteredEmployees.length}</span>
        </div>
      </div>

      <div className="filters">
        <div className="search ">
          <Select
            className="pr w-100"
            placeholder="Select Employee Name"
            isClearable
            options={employeeOptions}
            value={
              employeeOptions.find((emp) => emp.value === selectedEmployeeId) ||
              null
            }
            onChange={(option) => {
              setSelectedEmployeeId(option?.value || "");
              setDesignation(option?.designation || "");
              setSelectedStatus(option?.status || "");
              setSelectedDepartmentId(option?.depId || "");
            }}
          />
        </div>

        <div className="search">
          <Select
            className="pr w-100"
            placeholder="Select Department"
            isClearable
            value={
              departmentList
                .map((d) => ({ value: d.id, label: d.name }))
                .find((d) => d.value === selectedDepartmentId) || null
            }
            options={departmentList.map((d) => ({
              value: d.id,
              label: d.name,
            }))}
            onChange={handleDepartment}
          />
        </div>

        <div className="search">
          <Select
            className="w-100 pr"
            placeholder="Select Status"
            isClearable
            value={
              [
                { value: "VERIFIED", label: "Working" },
                { value: "BLOCKED", label: "Blocked" },
                { value: "LEFTOUT", label: "Left Organization" },
              ].find((s) => s.value === selectedStatus) || null
            }
            options={[
              { value: "VERIFIED", label: "Working" },
              { value: "BLOCKED", label: "Blocked" },
              { value: "LEFTOUT", label: "Left Organization" },
            ]}
            onChange={handleStatus}
          />
        </div>
      </div>

      {isFilterLoading && !isInitialLoading && (
        <div className="centered-loader">
          <ThreeDots height="80" width="80" color="blue" />
        </div>
      )}

      {!isFilterLoading && filteredEmployees.length === 0 && (
        <NoRecordsAvailable />
      )}

      {searchTerm && filteredEmployees.length > 0 && (
        <div className="container-fluid py-2">
          <div className="row g-3">
            {filteredEmployees.map((emp) => (
              <div className="col-md-4 col-lg-3" key={emp.id}>
                <EmployeeCard employee={emp} accessToken={accessToken} />
              </div>
            ))}
          </div>
        </div>
      )}

      {!isFilterLoading && !searchTerm && filteredEmployees.length > 0 && (
        <InfiniteScroll
          dataLength={filteredEmployees.length}
          next={fetchNextPage}
          hasMore={hasMore}
          loader={
            <div className="d-flex justify-content-center my-3">
              <ThreeDots height="50" width="50" color="blue" />
            </div>
          }
          style={{ overflow: "hidden" }}
        >
          <div className="container-fluid py-2">
            <div className="row g-3">
              {filteredEmployees.map((emp) => (
                <div className="col-md-4 col-lg-3" key={emp.id}>
                  <EmployeeCard employee={emp} />
                </div>
              ))}
            </div>
          </div>
        </InfiniteScroll>
      )}

      <Footer />
    </div>
  );
}

export default EmployeeList;
